import fr  from './fr';
import en  from './en';
import it  from './it';
import es  from './es';
import pt  from './pt';
import de  from './de';

export default {
  fr,
  en,
  it,
  es,
  pt,
  de
};